(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!button) return;

    var selector = button.closest('[data-quantity-selector]');
    var input = selector && selector.querySelector('.quantity-input');
    if (!input || input.disabled) return;

    var step = Number(input.step) || 1;
    var minimum = input.min === '' ? 0 : Number(input.min);
    var maximum = input.max === '' ? Infinity : Number(input.max);
    var current = Number(input.value);

    if (!Number.isFinite(current)) current = minimum;
    current += button.hasAttribute('data-quantity-plus') ? step : -step;
    input.value = Math.min(maximum, Math.max(minimum, current));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
